/**
 * created by zhouzt on 2020-04-22
 *
 * description: 供应商相关接口地址
 *
 */

const config = require('libs/config.js')

const supplier = {

}

export default supplier



// WEBPACK FOOTER //
// ./src/api/supplier/index.js